import styled from 'styled-components';

import { ENVIRONMENT_STATUS_COLORS } from 'shared/consts';

export const VoteContainer = styled.div`
  margin-top: 11px;
  background: ${({ theme }) => theme.colors.greys.adminGreyLight};
  border-radius: 9px;
  padding: 10px;
`;

export const VotePrompt = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 7px;
  color: ${({ theme }) => theme.colors.fontColor};
`;

export const VoteChips = styled.div`
  display: flex;
  gap: 5px;
`;

/**
 * The selected chip paints from the tenant theme like every other primary
 * control on the card (see CheckInButton) — this app is white-labeled, so the
 * design mock's HqO orange is not hardcoded, and text contrast rides on the
 * same theme guarantee as all primary buttons.
 */
export const VoteChip = styled.button<{ selected?: boolean; dimmed?: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: ${({ dimmed }) => (dimmed ? 'default' : 'pointer')};
  border: 1px solid ${({ selected, theme }) => (selected ? theme.colors.primary : theme.colors.greys.adminGreyMedium)};
  background: ${({ selected, theme }) => (selected ? theme.colors.primary : theme.colors.universal.white)};
  color: ${({ selected, theme }) => (selected ? theme.colors.universal.white : theme.colors.fontColor)};
  opacity: ${({ dimmed }) => (dimmed ? 0.45 : 1)};
`;

export const VoteAck = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${ENVIRONMENT_STATUS_COLORS.good};
  margin-top: 7px;
`;

export const VoteAckSub = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.greys.adminGreyDark};
  margin-top: 2px;
`;
